import { render } from "./Quest.vue?vue&type=template&id=71a38e5e"
import script from "./Quest.vue?vue&type=script&lang=js"
export * from "./Quest.vue?vue&type=script&lang=js"

import "./Quest.vue?vue&type=style&index=0&id=71a38e5e&lang=css"
script.render = render

export default script